import { render, staticRenderFns } from "./XmlFormatter.vue?vue&type=template&id=f3eb3012&scoped=true"
import script from "./XmlFormatter.vue?vue&type=script&lang=js"
export * from "./XmlFormatter.vue?vue&type=script&lang=js"
import style0 from "./XmlFormatter.vue?vue&type=style&index=0&id=f3eb3012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3eb3012",
  null
  
)

export default component.exports